import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { buttonBaseStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(actionsStyles, {
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            clear: both;
            margin-top: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-flow: column;
                    `,
                    css`
                        flex-flow: column;
                    `,
                    css`
                        margin-top: 0;
                    `,
                    css`
                        margin-top: 0;
                    `,
                    css`
                        margin-top: 0;
                    `,
                ])}
        `,
    },
    addAllToCartButton: {
        variant: "primary",
        css: css`
            ${buttonBaseStyles("solid")}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 10px;
                    `,
                    css`
                        margin-top: 10px;
                    `,
                    css`
                        margin-left: 10px;
                    `,
                    css`
                        margin-left: 10px;
                    `,
                    css`
                        margin-left: 10px;
                    `,
                ])}
        `,
    },
    addToListButton: {
        variant: "secondary",
        css: css`
            ${buttonBaseStyles("solid")}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 10px;
                    `,
                    css`
                        margin-top: 10px;
                    `,
                    css`
                        margin-left: 10px;
                    `,
                    css`
                        margin-left: 10px;
                    `,
                    css`
                        margin-left: 10px;
                    `,
                ])}
        `,
    },
});
